import styled from "styled-components";

export const Nav = styled.div`
  position: fixed;
  top: 0;
  z-index: 9998;
  height: 6rem;

  .burger-menu {
    position: relative;
    .navbar-menu {
      padding: 0;
    }
  }
  .navbar-wrapper {
    height: 100%;
    width: 100%;
  }

  .navbar-wrapper {
    .navbar-content {
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
      .navbar-item {
        .image {
          img {
            object-fit: cover;
          }
        }
      }
    }
  }
  .notburger-menu {
    display: none;
  }

  @media screen and (min-width: 768px) {
    .navbar-wrapper {
      width: 98%;
      margin: 0 auto;
    }
  }

  @media screen and (min-width: 1024px) {
    .navbar-wrapper {
      width: 90%;
      margin: 0 auto;
    }
    .burger-menu {
      display: none;
    }
    .notburger-menu {
      width: 100%;
      display: flex;
      flex-shrink: 1;
    }
    .navbar-dropdown {
      -moz-border-radius: 0px;
      -webkit-border-radius: 0 0 0.5rem 0.5rem;
      border-radius: 0 0 0.5rem 0.5rem;
    }
    .navbar-item:hover {
      color: #000000 !important;
    }
    /* .federationActive {
    display: ${({ $federationActive }) =>
      $federationActive ? "block" : "none"};
    transform: 0.3 ease-in-out;
    opacity: 1;
  }
  .bhActive {
    display: ${({ $bhActive }) => ($bhActive ? "block" : "none")};
    transform: 0.3 ease-in-out;
    opacity: 1;
  } */
  }
`;
